import { combineReducers, configureStore } from '@reduxjs/toolkit';
import projectReducer from '../../pages/project-management/project-details/data-access/project.reducer';
import { projectApi } from '../../pages/project-management/project-details/data-access/project.api';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../shared/+state/+root/root.saga';
import { createProjectSlice } from '../../pages/project-management/create-project/data-access/+state/project-create.reducer';
import { projectListSlice } from '../../pages/project-management/project-list/data-access/+state/project-list.reducer';
import { toastSlice } from '../../components/Toasts/data-access/toast-reducer';
import { userApi } from '../../pages/authentication/data-access/+state/user.api';
import { divisionsApi } from '../../pages/divisions/divisions.api';
import { logsApi } from '../../pages/project-management/project-details/data-access/logs.api';

// Initialize saga middleware (still needed for project management sagas)
const sagaMiddleware = createSagaMiddleware();
// Combine all reducers
export const rootReducer = combineReducers({
  project: projectReducer,
  [projectApi.reducerPath]: projectApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [divisionsApi.reducerPath]: divisionsApi.reducer,
  [logsApi.reducerPath]: logsApi.reducer,
  [createProjectSlice.name]: createProjectSlice.reducer,
  [projectListSlice.name]: projectListSlice.reducer,
  [toastSlice.name]: toastSlice.reducer
});

// Define RootState type
export type RootState = ReturnType<typeof rootReducer>;

// Configure the store
export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production', // Enable Redux DevTools in development
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false // Disable serializable checks
    })
      .concat(projectApi.middleware)
      .concat(userApi.middleware)
      .concat(divisionsApi.middleware)
      .concat(logsApi.middleware)
      .concat(sagaMiddleware)
});

sagaMiddleware.run(rootSaga);
// Export types for use throughout the app
export type AppDispatch = typeof store.dispatch;

// Export the store
export default store;
